import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useCompanyCache } from './cache'
import { type CompanyRemoveInput, type CompanyRemoveSuccess, Logger, toResponseError } from '@terros/common'

const logger = new Logger('useCompanies')

export function useRemoveCompany(): RemoveHookResponse<CompanyRemoveInput> {
  logger.verbose('calling useRemoveCompany')
  const cache = useCompanyCache()
  const mutation = useTantalimMutation<CompanyRemoveInput, CompanyRemoveSuccess>({ url: '/company/remove' })

  async function remove(input: CompanyRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearList()
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
